import logo from './logo.svg';
import './App.css';
import Navboot from "./NavBoot";
import {Routes, Route, Link, useLocation} from "react-router-dom";
import Backg from "./components/backg";
import React from "react";
import Contact from "./routes/contact";
import {Parallax, ParallaxLayer} from '@react-spring/parallax';
import {useState, Suspense, useEffect} from "react";
import {motion} from "framer-motion";

import leaf from './black-leaf.jpg';
import color from './colourful.jpg';
import Nav from "react-bootstrap/Nav";
import Skills1 from "./components/Skills1";
import Employment from "./components/Employment";
import Title from "./components/Title";

import checklist from "./icons/checklist.gif";
import hacker from "./icons/hacker.gif";
import message from "./icons/message.gif";
import mortarboard from "./icons/mortarboard.gif";
import diploma from "./icons/diploma.gif";
import certificate from "./icons/certificate.gif";
import ParticleImage from "./components/ParticleImage";
import AIPhotoEffect from "./components/AIPhotoEffect";
import {TabPane} from "react-bootstrap";
import Publications from "./components/Publications";
import Publications_List from "./components/Publications_List";
import CitationsChart from "./components/CitationsChart";
import LoadingScreen from './components/LoadingScreen';
import ProjectBlock from "./components/ProjectBlock";
import imageSrc from "./components/image"; // Import the image from image.js
import quantumimg from "./components/quantumimg"; // Import the quantum image
import blockchainimg from "./components/blockchain"; // Import the blockchain image
import AIimg from "./components/AIimg"; // Import the AI image
import powerimg from './components/powerimg';
import huaweiIMG from './components/huaweiIMG';
import Chatbot from "./components/Chatbot"; // Import the Chatbot component
import ParallaxAbout from "./components/ParallaxAbout";
import Timeline from './components/Timeline';
import ProjectsGallery from './components/ProjectsGallery';
import SkillsVisualization from './components/SkillsVisualization';
import Footer from './components/Footer'; // Add this import
const Name = 'Parham Mohammadi';
const Message = 'AI & Quantum Computing Researcher';
const Message2 = 'Large Language Models Expert';
const Message3 = 'MLOps & AI Systems Architect';
const Message4 = 'Quantum Computing Researcher';

function App() {
    const [currentTab, setCurrentTab] = React.useState("Home");
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Simulate loading time
        setTimeout(() => {
            setIsLoading(false);
        }, 3000); // 3 seconds loading time, adjust as needed
    }, []);

    React.useEffect(() => {
        const path = location.pathname.slice(1);
        if (path) {
            setCurrentTab(path.charAt(0).toUpperCase() + path.slice(1));
        } else {
            setCurrentTab("Home");
        }
    }, [location]);

    // Add new state for skills data
    const skillsData = [
        {
            name: "Large Language Models",
            category: "AI & Data Science",
            level: 95,
            description: "Expert in working with LLMs including GPT models, LLaMA, and BERT. Experienced in model deployment, optimization, and integration with applications.",
            projects: ["Custom LLM Chatbot", "Text Generation System"],
            icon: "🤖"
        },
        {
            name: "Prompt Engineering",
            category: "AI & Data Science",
            level: 90,
            description: "Specialized in advanced prompt engineering techniques for LLMs. Expertise in designing robust, context-aware prompts for various applications.",
            projects: ["AI Assistant Framework", "Content Generation System"],
            icon: "✍️"
        },
        {
            name: "Model Fine-tuning",
            category: "AI & Data Science",
            level: 88,
            description: "Experienced in fine-tuning large language models for specific domains and tasks. Proficient in techniques like LoRA, QLoRA, and parameter-efficient fine-tuning.",
            projects: ["Domain-Specific LLM", "Custom AI Model"],
            icon: "🎯"
        },
        {
            name: "Machine Learning",
            category: "AI & Data Science",
            level: 95,
            description: "Expert in developing and deploying machine learning models, with focus on deep learning and neural networks.",
            projects: ["AI Photo Effect", "Predictive Analytics System"],
            icon: "🧠"
        },
        {
            name: "MLOps",
            category: "DevOps",
            level: 92,
            description: "Expertise in ML model deployment, monitoring, and lifecycle management. Skilled in building robust ML pipelines.",
            projects: ["ML Pipeline Automation", "Model Monitoring System"],
            icon: "🔄"
        },
        {
            name: "Cloud Architecture",
            category: "DevOps",
            level: 90,
            description: "Experienced in designing and implementing cloud-native solutions using AWS and other cloud platforms.",
            projects: ["Microservices Platform", "Serverless API"],
            icon: "☁️"
        },
        {
            name: "Quantum Computing",
            category: "Quantum",
            level: 85,
            description: "Research and development in quantum algorithms and quantum machine learning.",
            projects: ["Quantum Simulation", "QML Algorithms"],
            icon: "⚛️"
        },
        {
            name: "TinyML",
            category: "AI & Data Science",
            level: 85,
            description: "Specialized in deploying ML models on resource-constrained devices and edge computing.",
            projects: ["Edge AI System", "IoT ML Implementation"],
            icon: "��"
        }
    ];

    // Add projects data
    const projectsData = [
        {
            id: 1,
            title: "MLOps & AI Systems",
            category: "AI & Machine Learning",
            shortDescription: "End-to-end MLOps implementation for complex ML applications, from TinyML to large language models.",
            fullDescription: "As an MLOps specialist and researcher with a PhD from York University, I focus on optimizing and deploying ML systems across scales - from TinyML to large language models. I specialize in implementing end-to-end MLOps practices for complex ML applications, with expertise in time series analysis and efficient model deployment.",
            technologies: ["MLOps", "LLMs", "TinyML", "Time Series Analysis"],
            image: AIimg,
            githubLink: "https://github.com/yourusername/mlops-systems"
        },
        {
            id: 2,
            title: "Enterprise ML Infrastructure",
            category: "MLOps",
            shortDescription: "Robust CI/CD pipelines and scalable infrastructure for ML model deployment at Huawei.",
            fullDescription: "At Huawei, I architect robust CI/CD pipelines for ML models, automate deployment workflows, and design scalable infrastructure for data processing and model training. My work involves optimizing models for resource-constrained environments and managing large language models in production.",
            technologies: ["CI/CD", "Infrastructure Design", "Model Optimization", "LLM Management"],
            image: huaweiIMG,
            githubLink: "https://github.com/yourusername/ml-infrastructure"
        },
        {
            id: 3,
            title: "Cloud-Native ML Platform",
            category: "Cloud Architecture",
            shortDescription: "Containerized ML solutions ensuring consistent model performance across diverse environments.",
            fullDescription: "I develop and deploy ML systems across different computational scales, from edge devices to cloud infrastructure. Using Docker and Kubernetes, I implement containerized solutions ensuring consistent model performance across diverse environments. My expertise spans modern ML frameworks including Python, Julia, TensorFlow, and major cloud platforms.",
            technologies: ["Docker", "Kubernetes", "Cloud Platforms", "ML Frameworks"],
            image: AIimg,
            githubLink: "https://github.com/yourusername/cloud-ml-platform"
        },
        {
            id: 4,
            title: "ML Systems Monitoring Platform",
            category: "MLOps",
            shortDescription: "Comprehensive monitoring and observability system for ML models in production.",
            fullDescription: "I specialize in designing monitoring and observability systems for ML models in production, focusing on time series forecasting and LLM deployment optimization. I build robust logging systems that track model performance, drift, and resource utilization across different deployment scenarios.",
            technologies: ["Monitoring", "Observability", "Performance Tracking", "Resource Optimization"],
            image: AIimg,
            githubLink: "https://github.com/yourusername/ml-monitoring"
        },
        {
            id: 5,
            title: "Quantum Machine Learning",
            category: "Quantum Computing",
            shortDescription: "Implementation of quantum algorithms for machine learning applications.",
            fullDescription: "A comprehensive implementation of quantum machine learning algorithms using Qiskit and IBM Quantum Experience. The project demonstrates quantum advantage in specific ML tasks.",
            technologies: ["Qiskit", "Python", "Machine Learning", "Quantum Computing"],
            image: quantumimg,
            githubLink: "https://github.com/yourusername/quantum-ml"
        }
    ];

    if (isLoading) {
        return <LoadingScreen />;
    }

    return (
        <div className="App" style={{ backgroundColor: '#000000' }}>
            <div className="full-screen-bg" style={{ 
                position: 'fixed', 
                top: 0, 
                left: 0, 
                right: 0, 
                bottom: 0, 
                zIndex: -1,
                backgroundColor: '#000000'
            }}>
                <AIPhotoEffect />
            </div>
            <header className="App-header" style={{ 
                backgroundColor: 'transparent', 
                position: 'relative', 
                zIndex: 1,
                color: '#ffffff'
            }}>
                <Parallax pages={4} style={{ backgroundColor: 'transparent' }}>
                    <ParallaxLayer 
                        offset={0} 
                        speed={0} 
                        factor={3} 
                        style={{
                            backgroundColor: "rgba(0,0,0,0)",
                            backgroundSize: 'cover',
                            zIndex: 100
                        }}
                    >
                        <Navboot setCurrentTab={setCurrentTab} />
                        {currentTab === "Home" && (
                            <div className="home-content">
                                <motion.div
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.8 }}
                                    className="home-title"
                                >
                                    <h1>{Name}</h1>
                                    <div className="home-subtitle">
                                        <motion.p
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            transition={{ delay: 0.5, duration: 0.8 }}
                                        >
                                            {Message}
                                        </motion.p>
                                        <motion.div
                                            className="role-titles"
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            transition={{ delay: 1, duration: 0.8 }}
                                        >
                                            <motion.p
                                                whileHover={{ scale: 1.05, color: 'var(--primary)' }}
                                                transition={{ duration: 0.2 }}
                                            >
                                                {Message2}
                                            </motion.p>
                                            <motion.p
                                                whileHover={{ scale: 1.05, color: 'var(--primary)' }}
                                                transition={{ duration: 0.2 }}
                                            >
                                                {Message3}
                                            </motion.p>
                                            <motion.p
                                                whileHover={{ scale: 1.05, color: 'var(--primary)' }}
                                                transition={{ duration: 0.2 }}
                                            >
                                                {Message4}
                                            </motion.p>
                                        </motion.div>
                                        <motion.div
                                            className="expertise-highlights"
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            transition={{ delay: 1.5, duration: 0.8 }}
                                        >
                                            <p className="highlight-text">Specializing in:</p>
                                            <div className="highlight-items">
                                                <span>🤖 LLM Fine-tuning & Deployment</span>
                                                <span>🧠 Advanced ML Systems</span>
                                                <span>⚛️ Quantum Algorithms</span>
                                                <span>🔄 MLOps & AI Infrastructure</span>
                                            </div>
                                        </motion.div>
                                    </div>
                                </motion.div>
                                <Footer />
                            </div>
                        )}
                        {currentTab === "About" && (
                            <div>
                                <Title SectionTitle={"About Me"}/>
                                <div className="about-me-content">
                                    <motion.div 
                                        className="about-sections"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        transition={{ duration: 0.5 }}
                                    >
                                        <motion.div 
                                            className="about-intro"
                                            initial={{ y: 20 }}
                                            animate={{ y: 0 }}
                                            transition={{ delay: 0.2 }}
                                        >
                                            <h2>Hello, I'm Parham! 👋</h2>
                                            <p>
                                                I'm an MLOps specialist and researcher with a PhD in electrical engineering and computer science from York University. 
                                                My passion lies in bridging the gap between cutting-edge AI research and practical applications.
                                            </p>
                                        </motion.div>

                                        <motion.div className="about-grid">
                                            <motion.div 
                                                className="about-card"
                                                whileHover={{ scale: 1.02 }}
                                                transition={{ type: "spring", stiffness: 300 }}
                                            >
                                                <div className="about-icon">🎯</div>
                                                <h3>Professional Overview</h3>
                                                <p>
                                                    My work focuses on optimizing and deploying machine learning systems across different scales, 
                                                    from edge devices to cloud infrastructure. I specialize in MLOps practices and efficient model deployment.
                                                </p>
                                                <div className="about-tags">
                                                    <span>AI</span>
                                                    <span>MLOps</span>
                                                    <span>Cloud Architecture</span>
                                                </div>
                                            </motion.div>

                                            <motion.div 
                                                className="about-card"
                                                whileHover={{ scale: 1.02 }}
                                                transition={{ type: "spring", stiffness: 300 }}
                                            >
                                                <div className="about-icon">🔬</div>
                                                <h3>Research Interests</h3>
                                                <p>
                                                    My research spans machine learning, quantum computing, and systems architecture. 
                                                    I'm passionate about making AI systems more efficient and accessible through better infrastructure.
                                                </p>
                                                <div className="about-tags">
                                                    <span>Machine Learning</span>
                                                    <span>Quantum Computing</span>
                                                    <span>Systems Architecture</span>
                                                </div>
                                            </motion.div>

                                            <motion.div 
                                                className="about-card"
                                                whileHover={{ scale: 1.02 }}
                                                transition={{ type: "spring", stiffness: 300 }}
                                            >
                                                <div className="about-icon">💡</div>
                                                <h3>Current Focus</h3>
                                                <p>
                                                    Currently advancing MLOps practices and exploring the intersection of quantum computing with machine learning. 
                                                    Developing efficient and scalable solutions for AI system deployment.
                                                </p>
                                                <div className="about-tags">
                                                    <span>AI Systems</span>
                                                    <span>Quantum ML</span>
                                                    <span>Infrastructure</span>
                                                </div>
                                            </motion.div>
                                        </motion.div>

                                        <motion.div 
                                            className="about-highlights"
                                            initial={{ y: 20 }}
                                            animate={{ y: 0 }}
                                            transition={{ delay: 0.4 }}
                                        >
                                            <h3>Key Highlights</h3>
                                            <div className="highlights-grid">
                                                <div className="highlight-item">
                                                    <span className="highlight-icon">📚</span>
                                                    <p>PhD in Computer Science & Electrical Engineering</p>
                                                </div>
                                                <div className="highlight-item">
                                                    <span className="highlight-icon">💻</span>
                                                    <p>Expert in MLOps & AI Systems Architecture</p>
                                                </div>
                                                <div className="highlight-item">
                                                    <span className="highlight-icon">🔗</span>
                                                    <p>Specialized in LLM Fine-tuning & Deployment</p>
                                                </div>
                                                <div className="highlight-item">
                                                    <span className="highlight-icon">⚛️</span>
                                                    <p>Active Research in Quantum Computing</p>
                                                </div>
                                            </div>
                                        </motion.div>
                                    </motion.div>
                                </div>
                                <Footer />
                            </div>
                        )}
                        {currentTab === "Experience" && (
                            <div>
                                <Title SectionTitle={"Experience"}/>
                                <Timeline events={[
                                    {
                                        date: "Jul 2023 - Present",
                                        title: "Associate Researcher",
                                        company: "Huawei",
                                        description: "Algorithm Development and Data Analysis in machine learning and energy patterns."
                                    },
                                    {
                                        date: "Aug 2022 - July 2023",
                                        title: "Blockchain Developer",
                                        company: "Lagrange Labs",
                                        description: "Optimizing cloud computing strategies, managing infrastructure as code, and containerizing applications. Working with Terraform, Docker, React.js and Node.js."
                                    },
                                    {
                                        date: "Sep 2019 - Present",
                                        title: "Teaching Assistant",
                                        company: "York University",
                                        description: "Teaching advanced algorithm design, embedded systems, and computational thinking courses. Mentoring students and developing course materials."
                                    },
                                    {
                                        date: "Sep 2019 - Present",
                                        title: "Research Assistant",
                                        company: "York University",
                                        description: "Research in Classical and Quantum Computing Methods for Simulation of Geomagnetic Disturbance Effects on Modern Power Systems."
                                    },
                                    {
                                        date: "Feb 2022 - Apr 2022",
                                        title: "NLP Engineer",
                                        company: "MeshGrid HR",
                                        description: "Creating NLP solutions for web automation and resume scanning using SPACY and NLTK."
                                    },
                                    {
                                        date: "Feb 2021 - Dec 2021",
                                        title: "Research and Development Engineer",
                                        company: "ChargeLab",
                                        description: "Developing machine learning algorithms for EV charging systems and managing technical project proposals."
                                    },
                                    {
                                        date: "May 2020 - Dec 2020",
                                        title: "Entrepreneurship Intern",
                                        company: "IBZ-Mitacs Accelerate",
                                        description: "Participating in Lab2Market program for commercializing research innovations. Developing business models and value propositions."
                                    }
                                ]} />
                                <Footer />
                            </div>
                        )}
                        {currentTab === "Education" && (
                            <div>
                                <Title SectionTitle={"Education"}/>
                                <div className="education-container">
                                    <motion.div 
                                        className="education-grid"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        transition={{ duration: 0.5 }}
                                    >
                                        <motion.div 
                                            className="education-card"
                                            whileHover={{ scale: 1.02 }}
                                            transition={{ type: "spring", stiffness: 300 }}
                                        >
                                            <div className="education-icon">
                                                <motion.span 
                                                    role="img" 
                                                    aria-label="phd"
                                                    initial={{ rotate: 0 }}
                                                    whileHover={{ rotate: 360 }}
                                                    transition={{ duration: 0.5 }}
                                                >
                                                    🎓
                                                </motion.span>
                                            </div>
                                            <div className="education-content">
                                                <h3>PhD in Computer Science and Electrical Engineering</h3>
                                                <h4>York University</h4>
                                                <p className="education-date">Sep 2019 - 2023</p>
                                                <p className="education-description">
                                                    Performing research and making cutting-edge sets of computational and numerical tools for analyzing the energy industry.
                                                </p>
                                                <div className="thesis-title">
                                                    <span>Thesis:</span> "Classical and Quantum Computing Methods for Simulation of Geomagnetic Disturbance Effects on Modern Power Systems"
                                                </div>
                                                <div className="education-tags">
                                                    <span className="education-tag">Quantum Computing</span>
                                                    <span className="education-tag">Machine Learning</span>
                                                    <span className="education-tag">Power Systems</span>
                                                </div>
                                            </div>
                                        </motion.div>

                                        <motion.div 
                                            className="education-card"
                                            whileHover={{ scale: 1.02 }}
                                            transition={{ type: "spring", stiffness: 300 }}
                                        >
                                            <div className="education-icon">
                                                <motion.span 
                                                    role="img" 
                                                    aria-label="masters"
                                                    initial={{ rotate: 0 }}
                                                    whileHover={{ rotate: 360 }}
                                                    transition={{ duration: 0.5 }}
                                                >
                                                    📚
                                                </motion.span>
                                            </div>
                                            <div className="education-content">
                                                <h3>Master of Science - MS</h3>
                                                <h4>Amir Kabir University of Technology</h4>
                                                <p className="education-date">Sep 2016 - 2019</p>
                                                <div className="education-tags">
                                                    <span className="education-tag">Computer Science</span>
                                                    <span className="education-tag">Advanced Computing</span>
                                                </div>
                                            </div>
                                        </motion.div>

                                        <motion.div 
                                            className="education-card"
                                            whileHover={{ scale: 1.02 }}
                                            transition={{ type: "spring", stiffness: 300 }}
                                        >
                                            <div className="education-icon">
                                                <motion.span 
                                                    role="img" 
                                                    aria-label="bachelors"
                                                    initial={{ rotate: 0 }}
                                                    whileHover={{ rotate: 360 }}
                                                    transition={{ duration: 0.5 }}
                                                >
                                                    🎯
                                                </motion.span>
                                            </div>
                                            <div className="education-content">
                                                <h3>Bachelor of Science - BS</h3>
                                                <h4>Iran University of Science and Technology</h4>
                                                <p className="education-date">Sep 2011 - 2015</p>
                                                <div className="education-tags">
                                                    <span className="education-tag">Computer Engineering</span>
                                                    <span className="education-tag">Software Development</span>
                                                </div>
                                            </div>
                                        </motion.div>
                                    </motion.div>
                                </div>
                                <Footer />
                            </div>
                        )}
                        {currentTab === "Skills" && (
                            <div>
                                <Title SectionTitle={"Skills"}/>
                                <SkillsVisualization skills={skillsData} />
                                <Footer />
                            </div>
                        )}
                        {currentTab === "Certificates" && (
                            <div>
                                <Title SectionTitle={"Certificates"}/>
                                <div className="certificates-container">
                                    <motion.div 
                                        className="certificates-grid"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        transition={{ duration: 0.5 }}
                                    >
                                        <motion.div className="certificate-category">
                                            <h2>Quantum Computing</h2>
                                            <div className="certificate-list">
                                                <motion.div 
                                                    className="certificate-card"
                                                    whileHover={{ scale: 1.02 }}
                                                    transition={{ duration: 0.2 }}
                                                >
                                                    <h3>Introduction to Quantum Computing for Everyone</h3>
                                                    <p className="issuer">edX</p>
                                                    <div className="certificate-details">
                                                        <span className="certificate-tag">Quantum Computing</span>
                                                        <span className="certificate-tag">Quantum Theory</span>
                                                    </div>
                                                </motion.div>
                                                <motion.div 
                                                    className="certificate-card"
                                                    whileHover={{ scale: 1.02 }}
                                                    transition={{ duration: 0.2 }}
                                                >
                                                    <h3>Architecture, Algorithms, and Protocols of a Quantum Computer and Quantum Internet</h3>
                                                    <p className="issuer">edX</p>
                                                    <div className="certificate-details">
                                                        <span className="certificate-tag">Quantum Architecture</span>
                                                        <span className="certificate-tag">Quantum Algorithms</span>
                                                    </div>
                                                </motion.div>
                                                <motion.div 
                                                    className="certificate-card"
                                                    whileHover={{ scale: 1.02 }}
                                                    transition={{ duration: 0.2 }}
                                                >
                                                    <h3>Fundamentals of Quantum Information</h3>
                                                    <p className="issuer">edX</p>
                                                    <div className="certificate-details">
                                                        <span className="certificate-tag">Quantum Information</span>
                                                        <span className="certificate-tag">Quantum Systems</span>
                                                    </div>
                                                </motion.div>
                                            </div>
                                        </motion.div>

                                        <motion.div className="certificate-category">
                                            <h2>Cloud & DevOps</h2>
                                            <div className="certificate-list">
                                                <motion.div 
                                                    className="certificate-card"
                                                    whileHover={{ scale: 1.02 }}
                                                    transition={{ duration: 0.2 }}
                                                >
                                                    <h3>AWS Cloud Essentials</h3>
                                                    <p className="issuer">Coursera</p>
                                                    <div className="certificate-details">
                                                        <span className="certificate-tag">AWS</span>
                                                        <span className="certificate-tag">Cloud Computing</span>
                                                    </div>
                                                </motion.div>
                                                <motion.div 
                                                    className="certificate-card"
                                                    whileHover={{ scale: 1.02 }}
                                                    transition={{ duration: 0.2 }}
                                                >
                                                    <h3>Introduction to Virtual Machines in Microsoft Azure</h3>
                                                    <p className="issuer">Coursera</p>
                                                    <div className="certificate-details">
                                                        <span className="certificate-tag">Azure</span>
                                                        <span className="certificate-tag">Virtual Machines</span>
                                                    </div>
                                                </motion.div>
                                            </div>
                                        </motion.div>

                                        <motion.div className="certificate-category">
                                            <h2>Programming & Development</h2>
                                            <div className="certificate-list">
                                                <motion.div 
                                                    className="certificate-card"
                                                    whileHover={{ scale: 1.02 }}
                                                    transition={{ duration: 0.2 }}
                                                >
                                                    <h3>Complete C# Masterclass</h3>
                                                    <p className="issuer">Udemy</p>
                                                    <div className="certificate-details">
                                                        <span className="certificate-tag">C#</span>
                                                        <span className="certificate-tag">.NET</span>
                                                    </div>
                                                </motion.div>
                                                <motion.div 
                                                    className="certificate-card"
                                                    whileHover={{ scale: 1.02 }}
                                                    transition={{ duration: 0.2 }}
                                                >
                                                    <h3>Project-based Python Workshop Series</h3>
                                                    <p className="issuer">IEEE</p>
                                                    <div className="certificate-details">
                                                        <span className="certificate-tag">Python</span>
                                                        <span className="certificate-tag">Project Development</span>
                                                    </div>
                                                </motion.div>
                                            </div>
                                        </motion.div>

                                        <motion.div className="certificate-category">
                                            <h2>Machine Learning & AI</h2>
                                            <div className="certificate-list">
                                                <motion.div 
                                                    className="certificate-card"
                                                    whileHover={{ scale: 1.02 }}
                                                    transition={{ duration: 0.2 }}
                                                >
                                                    <h3>How Google does Machine Learning</h3>
                                                    <p className="issuer">Coursera</p>
                                                    <div className="certificate-details">
                                                        <span className="certificate-tag">Machine Learning</span>
                                                        <span className="certificate-tag">Google Cloud</span>
                                                    </div>
                                                </motion.div>
                                                <motion.div 
                                                    className="certificate-card"
                                                    whileHover={{ scale: 1.02 }}
                                                    transition={{ duration: 0.2 }}
                                                >
                                                    <h3>Neural Networks and Deep Learning</h3>
                                                    <p className="issuer">Coursera</p>
                                                    <div className="certificate-details">
                                                        <span className="certificate-tag">Deep Learning</span>
                                                        <span className="certificate-tag">Neural Networks</span>
                                                    </div>
                                                </motion.div>
                                            </div>
                                        </motion.div>

                                        <motion.div className="certificate-category">
                                            <h2>Blockchain & Cryptography</h2>
                                            <div className="certificate-list">
                                                <motion.div 
                                                    className="certificate-card"
                                                    whileHover={{ scale: 1.02 }}
                                                    transition={{ duration: 0.2 }}
                                                >
                                                    <h3>Bitcoin and Cryptocurrencies</h3>
                                                    <p className="issuer">edX</p>
                                                    <div className="certificate-details">
                                                        <span className="certificate-tag">Blockchain</span>
                                                        <span className="certificate-tag">Cryptocurrency</span>
                                                    </div>
                                                </motion.div>
                                                <motion.div 
                                                    className="certificate-card"
                                                    whileHover={{ scale: 1.02 }}
                                                    transition={{ duration: 0.2 }}
                                                >
                                                    <h3>Cryptography I</h3>
                                                    <p className="issuer">Coursera</p>
                                                    <div className="certificate-details">
                                                        <span className="certificate-tag">Cryptography</span>
                                                        <span className="certificate-tag">Security</span>
                                                    </div>
                                                </motion.div>
                                            </div>
                                        </motion.div>
                                    </motion.div>
                                </div>
                                <Footer />
                            </div>
                        )}
                        {currentTab === "Honors" && (
                            <div>
                                <Title SectionTitle={"Honors"}/>
                                <div className="honors-container">
                                    <motion.div 
                                        className="honors-grid"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        transition={{ duration: 0.5 }}
                                    >
                                        <motion.div 
                                            className="honor-card"
                                            whileHover={{ scale: 1.02 }}
                                            transition={{ type: "spring", stiffness: 300 }}
                                        >
                                            <div className="honor-icon">
                                                <motion.span 
                                                    role="img" 
                                                    aria-label="award"
                                                    initial={{ rotate: 0 }}
                                                    whileHover={{ rotate: 360 }}
                                                    transition={{ duration: 0.5 }}
                                                >
                                                    🏆
                                                </motion.span>
                                            </div>
                                            <div className="honor-content">
                                                <div className="honor-header">
                                                    <h3>Lab2Market NSERC</h3>
                                                    <span className="honor-date">2024</span>
                                                </div>
                                                <h4>NSERC</h4>
                                                <p className="honor-description">
                                                    A pilot opportunity partnering with Lab2Market program to assess commercial potential for technology. 
                                                    The program includes a 16-week validation period with funding up to $20,000 for commercialization activities.
                                                </p>
                                                <div className="honor-value">
                                                    <span className="value-tag">Value: $20,000 CAD</span>
                                                </div>
                                            </div>
                                        </motion.div>

                                        <motion.div 
                                            className="honor-card"
                                            whileHover={{ scale: 1.02 }}
                                            transition={{ type: "spring", stiffness: 300 }}
                                        >
                                            <div className="honor-icon">
                                                <motion.span 
                                                    role="img" 
                                                    aria-label="fellowship"
                                                    initial={{ rotate: 0 }}
                                                    whileHover={{ rotate: 360 }}
                                                    transition={{ duration: 0.5 }}
                                                >
                                                    🎯
                                                </motion.span>
                                            </div>
                                            <div className="honor-content">
                                                <div className="honor-header">
                                                    <h3>Commercialization Fellowships</h3>
                                                    <span className="honor-date">2024</span>
                                                </div>
                                                <h4>York University</h4>
                                                <p className="honor-description">
                                                    Funded by the Office of the Vice-President Research & Innovation (VPRI) to support research commercialization 
                                                    and development of commercially viable projects.
                                                </p>
                                                <div className="honor-highlights">
                                                    <span className="highlight-tag">Part-time</span>
                                                    <span className="highlight-tag">4 months</span>
                                                    <span className="highlight-tag">8-10 hours/week</span>
                                                </div>
                                            </div>
                                        </motion.div>

                                        <motion.div 
                                            className="honor-card"
                                            whileHover={{ scale: 1.02 }}
                                            transition={{ type: "spring", stiffness: 300 }}
                                        >
                                            <div className="honor-icon">
                                                <motion.span 
                                                    role="img" 
                                                    aria-label="scholarship"
                                                    initial={{ rotate: 0 }}
                                                    whileHover={{ rotate: 360 }}
                                                    transition={{ duration: 0.5 }}
                                                >
                                                    🎓
                                                </motion.span>
                                            </div>
                                            <div className="honor-content">
                                                <div className="honor-header">
                                                    <h3>Carswell Scholarship</h3>
                                                    <span className="honor-date">2021</span>
                                                </div>
                                                <h4>York University</h4>
                                                <p className="honor-description">
                                                    Awarded to incoming doctoral students in the Lassonde School of Engineering who demonstrate outstanding academic achievement.
                                                </p>
                                                <div className="honor-value">
                                                    <span className="value-tag">Value: $10,000 CAD</span>
                                                </div>
                                            </div>
                                        </motion.div>

                                        <motion.div 
                                            className="honor-card"
                                            whileHover={{ scale: 1.02 }}
                                            transition={{ type: "spring", stiffness: 300 }}
                                        >
                                            <div className="honor-icon">
                                                <motion.span 
                                                    role="img" 
                                                    aria-label="research"
                                                    initial={{ rotate: 0 }}
                                                    whileHover={{ rotate: 360 }}
                                                    transition={{ duration: 0.5 }}
                                                >
                                                    🔬
                                                </motion.span>
                                            </div>
                                            <div className="honor-content">
                                                <div className="honor-header">
                                                    <h3>Lab2Market Research Award</h3>
                                                    <span className="honor-date">2020</span>
                                                </div>
                                                <h4>Mitacs</h4>
                                                <p className="honor-description">
                                                    Program providing training and support to teams looking to commercialize research emerging from Canadian universities.
                                                </p>
                                            </div>
                                        </motion.div>

                                        <motion.div 
                                            className="honor-card"
                                            whileHover={{ scale: 1.02 }}
                                            transition={{ type: "spring", stiffness: 300 }}
                                        >
                                            <div className="honor-icon">
                                                <motion.span 
                                                    role="img" 
                                                    aria-label="global"
                                                    initial={{ rotate: 0 }}
                                                    whileHover={{ rotate: 360 }}
                                                    transition={{ duration: 0.5 }}
                                                >
                                                    🌍
                                                </motion.span>
                                            </div>
                                            <div className="honor-content">
                                                <div className="honor-header">
                                                    <h3>LG Global Challenger Award</h3>
                                                    <span className="honor-date">2019</span>
                                                </div>
                                                <h4>LG</h4>
                                                <p className="honor-description">
                                                    Research award for emerging technologies from Canadian universities.
                                                </p>
                                                <div className="honor-value">
                                                    <span className="value-tag">Value: $15,000 CAD</span>
                                                </div>
                                            </div>
                                        </motion.div>

                                        <motion.div 
                                            className="honor-card"
                                            whileHover={{ scale: 1.02 }}
                                            transition={{ type: "spring", stiffness: 300 }}
                                        >
                                            <div className="honor-icon">
                                                <motion.span 
                                                    role="img" 
                                                    aria-label="presentation"
                                                    initial={{ rotate: 0 }}
                                                    whileHover={{ rotate: 360 }}
                                                    transition={{ duration: 0.5 }}
                                                >
                                                    🏅
                                                </motion.span>
                                            </div>
                                            <div className="honor-content">
                                                <div className="honor-header">
                                                    <h3>Best Presentation Award</h3>
                                                    <span className="honor-date">2021</span>
                                                </div>
                                                <h4>APEC 2021</h4>
                                                <p className="honor-description">
                                                    Recognition for outstanding presentation at the Applied Power Electronics Conference.
                                                </p>
                                            </div>
                                        </motion.div>
                                    </motion.div>
                                </div>
                                <Footer />
                            </div>
                        )}
                        {currentTab === "Contact" && (
                            <div>
                                <Title SectionTitle={"Contact"}/>
                                <div className="contacts-container">
                                    <motion.div 
                                        className="contacts-grid"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        transition={{ duration: 0.5 }}
                                    >
                                        <motion.div 
                                            className="contact-card"
                                            whileHover={{ scale: 1.05 }}
                                            transition={{ type: "spring", stiffness: 300 }}
                                        >
                                            <div className="contact-icon">
                                                <motion.span 
                                                    role="img" 
                                                    aria-label="email"
                                                    initial={{ rotate: 0 }}
                                                    whileHover={{ rotate: 360 }}
                                                    transition={{ duration: 0.5 }}
                                                >
                                                    📧
                                                </motion.span>
                                            </div>
                                            <h3>Email</h3>
                                            <motion.a 
                                                href="mailto:parhammoe@ieee.org"
                                                className="contact-link"
                                                whileHover={{ color: '#2ecc71' }}
                                            >
                                                parhammoe@ieee.org
                                            </motion.a>
                                        </motion.div>

                                        <motion.div 
                                            className="contact-card"
                                            whileHover={{ scale: 1.05 }}
                                            transition={{ type: "spring", stiffness: 300 }}
                                        >
                                            <div className="contact-icon">
                                                <motion.span 
                                                    role="img" 
                                                    aria-label="phone"
                                                    initial={{ rotate: 0 }}
                                                    whileHover={{ rotate: 360 }}
                                                    transition={{ duration: 0.5 }}
                                                >
                                                    📱
                                                </motion.span>
                                            </div>
                                            <h3>Phone</h3>
                                            <motion.a 
                                                href="tel:+1-4374237704"
                                                className="contact-link"
                                                whileHover={{ color: '#2ecc71' }}
                                            >
                                                +1-437-423-7704
                                            </motion.a>
                                        </motion.div>

                                        <motion.div 
                                            className="contact-card"
                                            whileHover={{ scale: 1.05 }}
                                            transition={{ type: "spring", stiffness: 300 }}
                                        >
                                            <div className="contact-icon">
                                                <motion.span 
                                                    role="img" 
                                                    aria-label="linkedin"
                                                    initial={{ rotate: 0 }}
                                                    whileHover={{ rotate: 360 }}
                                                    transition={{ duration: 0.5 }}
                                                >
                                                    💼
                                                </motion.span>
                                            </div>
                                            <h3>LinkedIn</h3>
                                            <motion.a 
                                                href="https://www.linkedin.com/in/parhammh/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="contact-link"
                                                whileHover={{ color: '#2ecc71' }}
                                            >
                                                linkedin.com/in/parhammh
                                            </motion.a>
                                        </motion.div>

                                        <motion.div 
                                            className="contact-card"
                                            whileHover={{ scale: 1.05 }}
                                            transition={{ type: "spring", stiffness: 300 }}
                                        >
                                            <div className="contact-icon">
                                                <motion.span 
                                                    role="img" 
                                                    aria-label="github"
                                                    initial={{ rotate: 0 }}
                                                    whileHover={{ rotate: 360 }}
                                                    transition={{ duration: 0.5 }}
                                                >
                                                    👨‍💻
                                                </motion.span>
                                            </div>
                                            <h3>GitHub</h3>
                                            <motion.a 
                                                href="https://github.com/parhammhe"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="contact-link"
                                                whileHover={{ color: '#2ecc71' }}
                                            >
                                                github.com/parhammhe
                                            </motion.a>
                                        </motion.div>

                                        <motion.div 
                                            className="contact-form-container"
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ delay: 0.3 }}
                                        >
                                            <h2>Get In Touch</h2>
                                            <p className="contact-description">
                                                Feel free to reach out for collaborations, opportunities, or just to say hello!
                                            </p>
                                            <div className="contact-highlights">
                                                <motion.div 
                                                    className="highlight"
                                                    whileHover={{ scale: 1.05 }}
                                                >
                                                    <span>🤝 Open to Collaborations</span>
                                                </motion.div>
                                                <motion.div 
                                                    className="highlight"
                                                    whileHover={{ scale: 1.05 }}
                                                >
                                                    <span>💡 Research Opportunities</span>
                                                </motion.div>
                                                <motion.div 
                                                    className="highlight"
                                                    whileHover={{ scale: 1.05 }}
                                                >
                                                    <span>🌟 Project Discussions</span>
                                                </motion.div>
                                                <motion.div 
                                                    className="highlight"
                                                    whileHover={{ scale: 1.05 }}
                                                >
                                                    <span>🌐 <a href="https://meshgridx.com" target="_blank" rel="noopener noreferrer" style={{color: '#ecf0f1', textDecoration: 'none'}}>meshgridx.com</a></span>
                                                </motion.div>
                                            </div>
                                        </motion.div>
                                    </motion.div>
                                </div>
                                <Footer />
                            </div>
                        )}
                        {currentTab === "Publications" && (
                            <div>
                                <Title SectionTitle={"Publications"}/>
                                <CitationsChart/>
                                <Publications_List/>
                                <Footer />
                            </div>
                        )}
                        {currentTab === "Projects" && (
                            <div>
                                <Title SectionTitle={"Projects"}/>
                                <ProjectsGallery projects={projectsData} />
                                <Footer />
                            </div>
                        )}
                    </ParallaxLayer>
                </Parallax>
            </header>
            <Chatbot />
        </div>
    )
}

export default App;